<template>
    <div>
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form @submit.stop>
                <div class="breadcrumb-area pos-relative w-100">
                    <h1>{{ dataRequest.id != '' ? "Cập nhật" : "Thêm mới" }}  nhóm người dùng</h1>
                    <div style="float: right;">
                        <button type="button" @click="$router.push('/customer-support/group-user')"
                            class="btn btn-light">
                            Quay lại
                        </button>
                        <button type="button" class="btn btn-light ml-2" @click="submitRequest()">
                            Lưu
                        </button>
                    </div>
                </div>
                <div class="card p-10 pt-15" style="overflow-x: hidden; overflow-y: auto">
                    <div class="card-body px-20 row">
                        <div class="col-md-12">
                            <h6>Thông tin chung</h6>
                            <ValidationProvider rules="required" vid="code" name="Mã nhóm" :persist="true">
                                <div class="form-group row" slot-scope="{ errors }">
                                    <label class="col-sm-1 col-form-label">
                                        Mã nhóm<span style="color: red"> *</span>
                                    </label>
                                    <div class="col-sm-4">
                                        <input class="form-control" v-model="dataRequest.code" :disabled="dataRequest.id != ''" />
                                        <p class="text-danger">{{ errors[0] }}</p>
                                    </div>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="required" vid="name" name="Tên nhóm" :persist="true">
                                <div class="form-group row" slot-scope="{ errors }">
                                    <label class="col-sm-1 col-form-label">
                                        Tên nhóm<span style="color: red"> *</span>
                                    </label>
                                    <div class="col-sm-4">
                                        <input class="form-control" v-model="dataRequest.name" />
                                        <p class="text-danger">{{ errors[0] }}</p>
                                    </div>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="note_1000" vid="description" name="Mô tả" :persist="true">
                                <div class="form-group row" slot-scope="{ errors }">
                                    <label for="" class="col-sm-1 col-form-label">Mô tả</label>
                                    <div class="col-sm-4">
                                        <textarea class="form-control" v-model.trim="dataRequest.description"
                                            placeholder="" rows="3" style="resize: none;"></textarea>
                                        <p class="text-danger">{{ errors[0] }}</p>
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-12">
                            <div class="tab-content" id="nav-tabContent">
                                <div class="p-10">
                                    <div class="float-left">
                                        <h6>Danh sách nhân viên nhóm</h6>
                                    </div>
                                    <div class="btn-group float-right">
                                        <button type="button" class="font-medium f12 btn btn-outline-secondary" @click="removeStaffAll">
                                            Xóa
                                        </button><button type="button"
                                            class="font-medium f12 btn btn-outline-secondary" @click="openModalAddStaff">
                                            Thêm thành viên
                                        </button>
                                    </div>
                                    <b-table :busy.sync="loading" sticky-header hover responsive :items="lists"
                                        :fields="filterTable" :fixed="true" :bordered="true">
                                        <template #table-busy>
                                            <div class="my-2 text-center">
                                                <b-spinner class="align-middle"></b-spinner>
                                            </div>
                                        </template>
                                        <template #head(checkbox)>
                                            <b-form-checkbox v-model="selectAll" @change="toggleSelectAll" :disabled="loading" />
                                        </template>
                                        <template #cell(checkbox)="data">
                                            <b-form-checkbox v-model="data.item.checked" />
                                        </template>

                                        <template #cell(index)="data">
                                            {{ getIndex(data.index) }}
                                        </template>
                                        <template #cell(staff)="data">
                                            <p><b-link :href="`/staff/detail/?id=${data.item.id}`" target="_blank"> {{ data.item.name }}</b-link></p>
                                            <p>{{ data.item.email ?? '' }}</p>
                                        </template>
                                        <template #cell(position)="data">
                                            <p>{{ data.item.position ? joinArrayData(data.item.position,positionMemberOption) : '' }}</p>
                                        </template>
                                        <template #cell(action)="data">
                                            <div class="text-left m-b-5">
                                                <b-link  style="color: #0056F6;" size="sm" v-if="data.item.position === 'MEMBER'" @click.prevent="setOwnerGroup(data.item.id)">
                                                    Đặt làm chủ sở hữu nhóm
                                                </b-link>
                                            </div>
                                            <div class="text-left m-b-5">
                                                <b-link  style="color: #0056F6;" size="sm" v-if="data.item.position === 'TEAMOWNERSHIP'" @click.prevent="removeOwnerGroup(data.item.id)">
                                                    Gỡ quyền sở hữu nhóm
                                                </b-link>
                                            </div>
                                            <div class="text-left m-b-5">
                                                <b-link  style="color: #0056F6;" size="sm" @click="removeStaff(data.item.id)">
                                                    Xóa
                                                </b-link>
                                            </div>
                                        </template>

                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </ValidationObserver>
        <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
        </VueLoadingOverlay>
        <PopupAddNewStaff ref="popupAddNewStaffRef" @addStaff="addStaff"/>
    </div>
</template>
<script>
import PopupAddNewStaff from './components/PopupAddNewStaff.vue';
import { Create, Update, Detail } from "@/services/customer-support/group-user";

const fieldsTable = [
    { key: 'checkbox', label: '', sortable: false, thStyle: 'width: 30px; text-align: center', },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: "staff", label: "Nhân viên", class: 'text-center' },
    { key: "position", label: "Chức vụ ( trong nhóm)", class: 'text-center' },
    { key: "action", label: "Thao tác", fixIndex: 999, class: "text-center" }
];

export default {
    components: {PopupAddNewStaff},
    data() {
        return {
            showLoading: false,
            loading: false,
            dataRequest: {
                id: '',
                code: '',
                name: '',
                description: '',
                memberList: [],
            },
            lists: [],
            filterTable: fieldsTable,
            positionMemberOption: [
                { id: 'MEMBER', text: 'Thành viên' },
                { id: 'TEAMOWNERSHIP', text: 'Sở hữu nhóm' },
            ],
            actionTeamMemberOption: [
                { id: 'NEW', text: 'Tạo mới' },
                { id: 'EDIT', text: 'Chỉnh sửa' },
                { id: 'DELETE', text: 'Xóa' },
            ],
            selectAll: false,
            search: {
                page: 1,
                limit: 10,
            },
            user: JSON.parse(localStorage.getItem("userData")),
        }
    },
    created() {
        this.dataRequest.id = this.$router.currentRoute.params.id ?? '';
        this.fetchData();
        this.addDefaultOwnerGroup();
    },
    computed: {
        joinArrayData() {
            return (item, options) => {
                const mapData = options.find(e => e.id === item);
                return mapData ? mapData.text : '';
            }
        },
        existsIds() {
          return this.lists.reduce((arr, item) => {
            arr.push(item.id);
            return arr;
          }, []);
        }
    },
    methods: {
        loadData() {
            this.list = res.data.listData.map(el => {
                return {
                    ...el,
                    checked: false,
                }
            });
        },
        toggleSelectAll() {
            this.lists.forEach(item => {
                item.checked = this.selectAll;
            });
        },
        openModalAddStaff() {
            this.$refs.popupAddNewStaffRef?.show(this.existsIds);
        },
        addStaff(staffs) {
            for (const staff of staffs) {
                if (!this.existsIds.includes(staff.id)) {
                    this.lists.push({
                        id: staff.id,
                        email: staff.userName,
                        name: staff.name,
                        checked: false,
                        position: 'MEMBER',
                    })
                }
            }
        },
        async submitRequest() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            const validateMember = this.lists.find(s => s.position === 'TEAMOWNERSHIP');
            if(!validateMember) return this.showFailMx('Phải có ít nhất một người sở hữu nhóm');

            // if (this.lists.length === 0) return this.showFailMx("Danh sách nhân viên nhóm không được để trống");

            if(this.dataRequest.id != ''){
                await this.update();
            } else {
                await this.create();
            }

        },
        async create() {
            try {
                this.showLoading = true;

                this.dataRequest.memberList = [...this.lists];
                const response = await Create(this.dataRequest);
                if(response.code === 1000){
                    this.showSuccessMx('Thêm mới nhóm người dùng').then(() =>
                        this.$router.push(`/customer-support/group-user`)
                    )
                }else {
                    this.showFailMx(response.message);
                }
            } catch (error) {
                this.showFailMx(error.message ?? error);
            } finally {
                this.showLoading = false;
            }
        },
        async update() {
            try {
                this.showLoading = true;

                this.dataRequest.memberList = [...this.lists];
                const response = await Update(this.dataRequest);
                if(response.code === 1000){
                    this.showSuccessMx('Cập nhật người dùng thành công')
                }else {
                    this.showFailMx(response.message);
                }
            } catch (error) {
                this.showFailMx(error.message ?? error);
            } finally {
                this.showLoading = false;
            }
        },
        setOwnerGroup(id) {
            this.lists.forEach(item => {
                if(item.id === id) {
                    item.position = 'TEAMOWNERSHIP';
                }
            });
        },
        removeOwnerGroup(id) {
            const validateMember = this.lists.filter(s => s.position === 'TEAMOWNERSHIP');
            if(validateMember.length === 1) return this.showFailMx('Phải đặt người khác làm sở hữu nhóm');

            this.lists.forEach(item => {
                if(item.id === id) {
                    item.position = 'MEMBER';
                }
            });
        },
        removeStaff(id) {
            this.lists = this.lists.filter(item => item.id != id);
        },
        removeStaffAll(){
            this.lists = this.lists.filter(item => !item.checked);
            this.selectAll = false;
        },
        async fetchData() {
            if(this.dataRequest.id != ''){
                try {
                    this.showLoading = true;
                    const response = await Detail({id: this.dataRequest.id});
                    if(response.code === 1000 && response.data){
                        this.dataRequest.code = response.data.code ?? '';
                        this.dataRequest.name = response.data.name ?? '';
                        this.dataRequest.description = response.data.description ?? '';
                        this.lists = response.data.teamUsers ? response.data.teamUsers.reduce((acc,current) => {
                           acc.push({
                            id: current.userId,
                            position: current.position,
                            email: current.email,
                            name: current.name,
                            checked: false,
                           });

                            return acc;
                        },[]) : [];
                        if(this.lists.length > 0){
                            this.lists.sort((a, b) => {
                                if (a.position === 'TEAMOWNERSHIP' && b.position !== 'TEAMOWNERSHIP') {
                                    return -1;
                                }
                                if (a.position !== 'TEAMOWNERSHIP' && b.position === 'TEAMOWNERSHIP') {
                                    return 1;
                                }
                                return 0;
                            })
                        }
                    }else {
                        this.showFailMx(response.message)
                    }
                } catch (error) {
                    this.showFailMx(error.message ?? error)
                } finally {
                    this.showLoading = false;
                }
            }
        },
        addDefaultOwnerGroup() {
            this.lists.push({
                id: this.user.userId ?? '',
                email: this.user.username ?? '',
                name: this.user.name ?? '',
                checked: false,
                position: 'TEAMOWNERSHIP',
            })
        }
    },
}
</script>
<style scoped></style>
